import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { humanizeTime, i18nIntl } from '../../lib/ep';

import GameContainer from './GameContainer.js';

import GuessWordCanvas from '../games/GuessWordCanvas';
import MisconfiguredGameWarning from './MisconfiguredGameWarning.js';
import { clientFinalPage } from '../games/StageFinalMessages.js';

const Instructions = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const stage = props.stage.Stage;
	const game_time = (stage.game_time != undefined) ? stage.game_time : 30;
	const words_to_solve = stage?.guessword_min_words ?? (stage?.guessword_words ?? []).length;

	return (
		<>
			<div class="instructions_section gui_text_block challenge">
				<strong class="title">{i18n("Your challenge")}</strong>

				<div>{(words_to_solve > 1) ? <FormattedMessage id="Find {total} words in {time}" values={{total:words_to_solve, time:humanizeTime(game_time, i18n)}} /> : <FormattedMessage id="Find 1 word in {time}" values={{time:humanizeTime(game_time, i18n)}} />}</div>
			</div>

			<div class="instructions_section gui_text_block main_instructions">
				<strong class="title">{i18n("How to play?")}</strong>

				<div>{i18n("Sort the letters to find the words")}</div>
			</div>
		</>
	)
};

const GuessWordClient = ({ stage, ...props }) => {
	const final_stage = clientFinalPage(stage, props.actual_state);

	return (
		<GameContainer
			{...props}
			stage={final_stage}
			display_attemps={false}
			instructions_as_game={true}
			instructions_at_top={true}
			instructions={<Instructions
				stage={stage}
				intl={props.intl}
			/>}
			game_type="guessword"
			display_audio_controls={true}
			//auto_start_timer={false}
		>
			{((stage.Stage?.guessword_words ?? []).length > 0) ? (
				<GuessWordCanvas
					locale={props.locale}
				/>
			) : (
				<MisconfiguredGameWarning
					message="Still missing a word"
				/>
			)}
			
		</GameContainer>
	)
};

export default injectIntl(GuessWordClient);